module.exports = __webpack_public_path__ + "img/safetyImg5.80d53a7c.png";